import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { startApp } from './actions/StartApp.Actions';
import './App.sass';

import Aside from './containers/Aside/Aside';
import TopBar from './containers/TopBar/TopBar';
import LoadingModal from './containers/Main/LoadingModal';
import Main from './containers/Main/Main';

class App extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    /* Load data for the model evaluation system */
    dispatch(startApp(this.props.history));
  }

  render() {
    const { showAside } = this.props;

    return (
      <div className="App">
        <Aside />
        <TopBar />
        <LoadingModal />
        <div className={`app-wrapper ${showAside ? 'show-aside' : ''}`}>
          <Main />
        </div>
      </div>
    );
  }
}

App.propTypes = {
  showAside: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps({ UI: { showAside }, StartApp: { loading } }) {
  return { showAside, loading };
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.jsx